<div class="overlay">

  <div class="eula-modal">

<!--    <h2>End User License Agreement (EULA)</h2>-->
    <h2>App License Agreement </h2>

    <div
      class="eula-content"
      (scroll)="onScroll($event)">

      <markdown [src]="eulaFile"></markdown>

    </div>

    @if (!hasScrolledToBottom()) {
      <div class="warning">
        Please scroll through the agreement to continue.
      </div>
    }
    @else {
      @if (bypassDaysRemaining > 0) {
      <div class="countdown-banner">
        Temporary bypass access expires in:
        <span class="days-left">
            {{ bypassDaysRemaining }} days
          </span>
      </div>
      }
      @else {
      <div class="expired-banner">
        Bypass is no longer available. Acceptance is required to continue.
      </div>
      }
    }


    <div class="actions">

      <button
        class="accept-btn"
        [disabled]="!hasScrolledToBottom()"
        (click)="accept()">

        Accept
      </button>
      @if (bypassDaysRemaining > 0)
      {
        <button
          class="bypass-btn"
          [disabled]="!hasScrolledToBottom()"
          (click)="bypass()">

          Bypass
        </button>
      }
    </div>

    <div class="eula-footer">
      Version {{ eulaVersion }}
    </div>
  </div>

</div>
